const getSearch = (): string => location.search;

export { getSearch };
